import React from 'react';

import { Article } from '../../../interfaces/homepage';
import SectionBreakTitle, { SectionColor } from '../../SectionBreakTitle';
import ProArticleItem from './ProArticleItem';

interface ProArticlesProps {
  proArticles: Article[];
}

const ProArticles = ({ proArticles }: ProArticlesProps) => {
  return (
    <div className="border-0 border-b border-solid border-pro-gold">
      <SectionBreakTitle
        title="Recent Pro articles"
        titleClassName="text-pro-gold"
        color={SectionColor.Gold}
      />
      <div className="flex flex-col justify-center py-32 sm:flex-row sm:gap-48 md:gap-56">
        {proArticles.map((article) => (
          <ProArticleItem key={article.id} article={article} />
        ))}
      </div>
    </div>
  );
};

export default ProArticles;
